// Libraries
import React from 'react';
import styled from 'styled-components';
import { Droppable } from 'react-beautiful-dnd';

// Components
import MenuItem from './components/MenuItem';

interface IMenu {
	children?: React.ReactNode;
	style?: React.CSSProperties;
	className?: string;
	isDropable?: boolean;
	droppableId: string;
}

const StyledMenu = styled.div`
	.menu-group {
		:not(:last-child) {
			border-bottom: 1px solid #e5e5e5;
		}
	}
`;

const Menu: any = (props: IMenu) => {
	// Props
	const { children, style, className, isDropable, droppableId } = props;

	return (
		<Droppable droppableId={droppableId} isDropDisabled={!isDropable}>
			{(provided) => (
				<StyledMenu {...props} {...provided.droppableProps} style={style} className={className} ref={provided.innerRef}>
					{children}
					{provided.placeholder}
				</StyledMenu>
			)}
		</Droppable>
	);
};

Menu.defaultProps = {
	droppableId: 'antsomi-menu',
	children: null,
	style: {},
	className: '',
	isDropable: false,
};

Menu.Item = MenuItem;

export default Menu;
